import { render, staticRenderFns } from "./BlClients.vue?vue&type=template&id=63f2b507&"
import script from "./BlClients.vue?vue&type=script&lang=js&"
export * from "./BlClients.vue?vue&type=script&lang=js&"
import style0 from "./BlClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports